import { ErrorBoundary } from 'react-error-boundary';
import { RecordingControls } from './RecordingControls';
import { RecordingControlsError } from './RecordingControlsError';

export const SafeRecordingControls = () => {
  return <ErrorBoundary FallbackComponent={RecordingControlsError}>
    <RecordingControls></RecordingControls>
  </ErrorBoundary>
}
